export const pollInterval = 15 * 60 * 1000; //15 min